import React, { useEffect, useState } from 'react';
import { Typography, Box, CircularProgress, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material';

import { Delete } from '@mui/icons-material';
import Layout from '../../components/layout';
import { db } from '../../firebaseconf';
import { collection, query, getDocs, deleteDoc, doc } from "firebase/firestore";
import Header from '../../components/header';
import Alerts from '../../components/alert';

export default function RemoveStudent() {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    useEffect(() => {
        setLoading(true);
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) {
            setLoading(false);
            return;
        }

        const q = query(collection(db, 'institutions', loggedUser.institution_id, 'students'));

        getDocs(q).then(snapshot => {
            const displayItem = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setStudents(displayItem);
            setLoading(false);
        }).catch(error => {
            console.error("Error fetching students:", error);
            setLoading(false);
        });
    }, []);

    const handleDeleteStudent = async (id) => {
        setLoading(true);
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) {
            setLoading(false);
            return;
        }

        const studentRef = doc(db, 'institutions', loggedUser.institution_id, 'students', id);

        try {
            await deleteDoc(studentRef);
            setAlertMessage('Student removed successfully!');
            setAlertVisible(true);
            setStudents(students.filter(s => s.id !== id));
        } catch (error) {
            console.error("Error removing student:", error);
            setAlertMessage('Error removing student!');
            setAlertVisible(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Header title="Remove Student" />
            <Box component="section" sx={{ p: 5 }}>
                {alertVisible && <Alerts message={alertMessage} type="success" color="success" />}
                {loading && <CircularProgress sx={{ display: 'block', margin: '10px auto' }} />}

                <List>
                    {students.length > 0 ? (
                        students.map(student => (
                            <ListItem key={student.id} divider>
                                <ListItemText primary={student.name} secondary={`Roll No: ${student.roll_number}`} />
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" color="error" onClick={() => handleDeleteStudent(student.id)}>
                                        <Delete />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))
                    ) : (
                        <Typography>No students found.</Typography>
                    )}
                </List>
            </Box>
        </Layout>
    );
}
